var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "371px",
    height: "371px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#6ab232",
    d: "M 169.5,53.5 C 196.398,52.202 222.731,55.3687 248.5,63C 281.76,75.5991 303.26,99.0991 313,133.5C 322.705,174.23 321.372,214.564 309,254.5C 296.416,285.079 274.249,305.246 242.5,315C 200.081,326.053 158.081,324.719 116.5,311C 86.3659,298.199 66.8659,276.032 58,244.5C 48.0001,206.833 48.0001,169.166 58,131.5C 69.3365,94.1638 93.8365,70.3305 131.5,60C 144.18,57.054 156.846,54.8873 169.5,53.5 Z M 123.5,118.5 C 145.714,116.846 166.214,121.846 185,133.5C 212.94,116.351 242.107,114.018 272.5,126.5C 272.349,144.781 266.516,161.115 255,175.5C 246.13,185.753 235.797,194.086 224,200.5C 224.801,233.894 211.968,260.56 185.5,280.5C 164.722,266.632 152.222,247.299 148,222.5C 147.733,214.764 146.9,207.098 145.5,199.5C 116.398,184.228 100.231,160.228 97,127.5C 105.406,123.029 114.24,120.029 123.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#6ab232",
    d: "M 122.5,136.5 C 147.56,133.24 168.727,140.573 186,158.5C 188.734,163.458 190.234,168.791 190.5,174.5C 204.386,168.513 207.386,159.179 199.5,146.5C 206.888,141.089 215.221,137.922 224.5,137C 233.895,136.114 243.228,136.447 252.5,138C 253.554,139.388 253.72,140.888 253,142.5C 245.073,165.427 229.573,180.594 206.5,188C 202.167,188.667 197.833,188.667 193.5,188C 190.452,187.394 187.952,185.894 186,183.5C 183.209,199.315 189.709,206.982 205.5,206.5C 206.162,226.018 199.829,242.852 186.5,257C 185.5,257.667 184.5,257.667 183.5,257C 164.567,235.67 159.734,211.504 169,184.5C 171.921,180.908 175.421,178.075 179.5,176C 167.383,166.735 157.216,168.569 149,181.5C 132.635,172.12 121.802,158.287 116.5,140C 116.645,139.228 116.978,138.561 117.5,138C 119.382,137.802 121.048,137.302 122.5,136.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/ON.ea52f4db70016fb92664daf348715dc1.svg";
export { ForwardRef as ReactComponent };